module.exports = __webpack_public_path__ + "media/images/author-affiliations-a57e4b618443a869af66e9aa614ab374.png";